//*** Import React Library
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "../../Assets/Styles/robot.css";
import { Route, Routes } from 'react-router-dom';
import { hasJWTToken } from "../Account/RouteGuard";
import Axios from 'axios'
import AxiosInstance from '../Axios/AxiosInstance';
Axios.defaults.baseURL = "https://localhost:7248";
//Axios.defaults.baseURL = "https://bhuhit.com/api";
//*** Create columns for react table
const columns = [
    { name: "Error Log Time", selector: (row) => row.errorLogTime, sortable: true },
    { name: "Robot ID", selector: (row) => row.robotID, sortable: true },
    { name: "Error Level", selector: (row) => row.errorLevel, sortable: true },
    { name: "Error Code", selector: (row) => row.errorCode, sortable: true },
    { name: "Error Message", selector: (row) => row.errorDescriptions, sortable: true },
    { name: "Error Source", selector: (row) => row.errorSource, sortable: true },
    { name: "Error Source Code", selector: (row) => row.errorSourceCode, sortable: true },
];
//*** Create custom style for react table
const customStyles = {
    table: {
        style: {
            border: "none",
            fontSize: "100%"
        },
    },
    header: {
        backgroundColor: "transparent",
    },
    rows: {
        style: {
            backgroundColor: "transparent",
        },
    },
    headRow: {
        style: {
            backgroundColor: "transparent",
            fontSize: "110%"
        },
    },
    pagination: {
        style: {
            backgroundColor: "transparent",
            fontWeight: "600",
        },
    },
    headCells: {
        style: {
            borderBottom: "none",
            fontWeight: "700",
            fontSize: "110%"
        },
    },
};

//*** Error log component 
export const ErrorLog = () => {
    const [searchTerm1, setSearchTerm1] = useState("");
    const [data1, setData1] = useState([])
    const [list1, setList1] = useState([])
    //*** Seach  Textbox text change event
    const handleSearch1 = (event) => {
        try {
            setSearchTerm1(event.target.value);
            let tempList1 = data1;
            const filteredData1 = tempList1.filter((event) =>
                Object.values(event).some(
                    (value) => typeof value === "string" && value.includes(searchTerm1)
                )
            );
            if (event.target.value != null) {
                setList1(filteredData1);
            }
            if (event.target.value === "") {
                setList1(data1);
            }
        }
        catch(error) {
            console.log("Error in Error Log")
        }
    };
        const filteredData1 = list1.filter((event) =>
            Object.values(event).some(
                (value) => typeof value === "string" && value.includes(searchTerm1)
            )
        );
   
    const handleRowSelected = (rows) => {
        setData1(rows.selectedRows);
    };
    useEffect(() => {
        fetchData1();
    }, [])
    useEffect(() => {
        console.log(data1)
    }, [data1])
    const fetchData1 = async () => {
        var plant_id = sessionStorage.getItem("user_plantid");
        try {
            let response = await AxiosInstance.get("/Error/ErrorLog?pid=1");
            setData1(response.data)
            setList1(response.data)
           // console.log(data1)
            //if (response && typeof response.then === 'function') {
            //const response = await Axios("/RobotLevelCurrentSprayingStatus?pid=" + plant_id + "");
                //response.then((res) => {
                //    if (res.data) {
                //       //setData(response.data)
                //        //setList(response.data)
                //        console.log(data)
                //    }
                //})
                //response.catch(
                //    function (error) {
                //        console.log('Error Message:' + error)
                //    }
                //)
            //}
            //else {
            //    console.log("Response is not a promise");
            //}
        }
        catch (error) {
            console.log("err");
        }
    }
    // *** Return html code 
    return (
        <>
            <h3 style={{ margin: "2%", marginLeft: "2%" }}>Error Log Montoring, Analysis, Reporting & Visualization</h3>
            <div
                style={{
                    border: "1px solid #c0c0c0",
                    borderRadius: "5px",
                    margin: "2%",
                    backgroundColor: "#fff",
                    color: "#000",
                }}
            >
                <div className="container dvscroll error_popup" tyle={{width: "100%", height: "70%", fontSize: "92%" }} >
                    <div className="row dvscroll error_popup">
                        <div className="col-sm-12">
                            <input
                                type="text"
                                placeholder="Search Results"
                                style={{
                                    width: "20%",
                                    height: "30px",
                                    margin: "10px",
                                    float: "right",
                                    border: "none",
                                    padding: "1.5%",
                                    borderRadius: "5px",
                                }}
                                value={searchTerm1}
                                onChange={handleSearch1}
                                id="searchErrorLog"
                            />
                            <p></p>
                            <DataTable className="table .table-sm table-hover error_popup" sort={true} pagination={true}
                                search={true}
                                columns={columns}
                                data={filteredData1}
                                highlightOnHover={true}
                                customStyles={customStyles}
                            >
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
